import { object, string } from 'yup';

import client from '$app-web/core/client';

const requestSchema = object().shape({
    username: string(),
    password: string(),
    send: string().default(true),
});

export const useFetchMFAEnabled = client.registerEndpoint('POST api/fetch-mfa-enabled', `/v1/auth/2fa/`, {
    requestSchema,
    mutate: true,
});
